import { styled } from '@/src/stitches.config'

export const HeaderText = styled('h1', {
    color: '$darkest',
    margin: 0,
})

export const BackButton = styled('div', {
    display: 'flex',
    ai: 'center',
    width: 'max-content',
    mr: '30px',
    cursor: 'pointer',
    zIndex: 2,
})

export const Wrapper = styled('div', {
    display: 'flex',
    minHeight: '50vh',
    width: '$default',
    maxWidth: '$defaultMax',
    margin: 'auto',
})

export const CenteredFlexDiv = styled(Wrapper, {
    minHeight: '70vh',
    width: '100%',
    maxWidth: '100%',
    ai: 'center',
    jc: 'center',
})

export const ResponsiveWhiteBox = styled('div', {
    backgroundColor: '$white',
    padding: '30px 20px',
    width: '100%',
    height: 'fit-content',
    br: 20,
    '@media (min-width:660px)': {
        width: '48%',
    },
    '@lg': {
        padding: 30,
    },
    '#card-container': {
        maxWidth: '100% !important',
    },
})

export const ClearBoxWrapper = styled('div', {
    display: 'flex',
    fd: 'column',
    gap: 20,
    width: '100%',
    height: 'fit-content',
    '@media (min-width:660px)': {
        width: '50%',
    },
})

export const FullWidthWhiteBox = styled('div', {
    backgroundColor: '$white',
    padding: 20,
    width: '100%',
    height: 'fit-content',
    br: 20,
    '@lg': {
        padding: 30,
    },
    '#card-container': {
        maxWidth: '100% !important',
    },
})

export const GiftsWrapper = styled('div', {
    display: 'flex',
    fd: 'column',
    gap: '40px',
    mt: 20,
    minHeight: 200,
    '@media (min-width: 745px)': {
        gap: '55px 5%',
    },
    '@sm': {
        fd: 'row',
        flexWrap: 'wrap',
    },
})

export const ContentWrapper = styled('div', {
    display: 'flex',
    fd: 'column',
    gap: 20,
    '@media (min-width:660px)': {
        fd: 'row',
        jc: 'space-between',
    },
    '.social-icons': {
        mb: 0,
    },
    variants: {
        margin: {
            default: {
                mt: 20,
            },
            none: {},
        },
    },
    defaultVariants: {
        margin: 'default',
    },
})
